import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { BranchHttpService } from 'src/app/http/branch-http.service';
import { OfferHttpService } from 'src/app/http/offer-http.service';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';

@Component({
    selector: 'app-voucher-list',
    templateUrl: './voucher-list.component.html',
    styles: [],
})
export class VoucherListComponent implements OnInit {
    constructor(private activatedRoute: ActivatedRoute, private modalService: NgbModal, private offerHttpService: OfferHttpService, private router: Router) {}

    tempItems = [];

    items = [];

    totalItems = this.items.length;

    searchBoxControl = new FormControl();

    @ViewChild('table') table: DatatableComponent;

    @ViewChild(AlertComponent) alert: AlertComponent;

    ngOnInit(): void {
        this.routeData();
        this.routeHistory();
    }

    routeHistory() {
        if (history.state.hasState) {
            setTimeout(() => {
                this.alert.addAlert({ type: history.state.type, message: history.state.message });
            });
        }
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.items = data.data;
            this.tempItems = data.data;
        });
    }

    tableFiltring(event: any) {
        const val = event.target.value.toString().toLowerCase();
        const temp = this.tempItems.filter(function (d) {
            return d.dicountValue.toString().toLowerCase().indexOf(val) !== -1 || !val;
        });
        this.items = temp;
        this.table.offset = 0;
    }

    confirmDelete(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = 'Delete';
        confirm.componentInstance.messageLabel = 'Are you sure you want to delete this item?';
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.delete(item);
                }
            },
            () => {}
        );
    }

    delete(item: any) {
        this.offerHttpService.deleteVouchercode(item.discountCodeId).subscribe(() => {
            this.deleteItem(item.discountCodeId);
            this.alert.addAlert({ type: 'success', message: 'Discount Code Deleted successfully' });
        });
    }

    deleteItem(itemId: any) {
        this.tempItems = this.tempItems.filter((c) => c.discountCodeId != itemId);
        this.items = this.tempItems;
    }
}
